import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ToastService from "../../../Admin/services/ToastService";
import ClientService from "../../services/ClientService";
import $ from "jquery";
import "datatables.net";
import { Toast } from "primereact/toast";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Clients() {
  const query = useQuery();
  const tableRef = useRef(null);
  const [Clients, setClients] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);
  const toastService = new ToastService(toast);

  async function fetchClients() {
    try {
      const clientsData = await ClientService.getAllCLients();
      setClients(clientsData);
    } catch (error) {
      console.error("Error fetching Clients:", error);
      toastService.showError("Error", "Failed to fetch clients data");
    }
  }

  useEffect(() => {
    fetchClients();

    setTimeout(() => {
      $("#tableData").DataTable();
    }, 1000);
  });

  const renderClients = () => {
    return Clients.map((client) => {
      return (
        <tr key={client.id} className="table display" style={{ width: "100%" }}>
          <td>{client.agencyName}</td>
          <td>{client.email}</td>
          <td>{client.phoneNumber}</td>
          <td>{client.streetAddress}</td>
          <td>{client.city}</td>
          <td>{client.state}</td>
          <td>{client.country}</td>
          <td>{client.postalCode}</td>
          <td>{client.gstNumber}</td>
          <td>{client.license}</td>
          <td>{client.registrationNumber}</td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => navigate(`/editClient/${client.id}`)}
              >
                <i className="pi pi-pencil" style={{ fontSize: "1.5rem" }}></i>
              </button>
            </span>
          </td>
        </tr>
      );
    });
  };

  return (
    <div>
      <Toast ref={toast} />

      <div className="form-group row">
        <div className="col-lg-12 float-end">
          <div className="col-lg-3 float-end">
            <a
              class="btn bg-gradient-dark mb-0 float-end"
              href="javascript:;"
              onClick={() => {
                navigate("/addClient");
              }}
            >
              Add Client
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card my-4">
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0" id="tableData">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Agency Name
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Email
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Phone Number
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Street Address
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      City
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      State
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Country
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Postal Code
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Gst Number
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      License
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Registration Number
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>{renderClients()}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clients;
